import { ConfirmOtpPage } from '@/features/account/ConfirmOtpPage'

/**
 * The registration branch: confirming the code activates the account and drops
 * the user on the home page.
 * Views/Account/ConfirmEmailRegist.cshtml + wwwroot/js/app/account/confirmEmailRegist.js.
 *
 * On a missing session the original sent the user to `/Account/Registrasi`
 * (confirmEmailRegist.js:38) — a route that does not exist; the controller
 * action is `Register`, and ASP.NET answered 404. Corrected to /Account/Register.
 */
export function ConfirmEmailRegist(): JSX.Element {
  return (
    <ConfirmOtpPage
      title="Confirm Email"
      resendLabel="Resend OTP"
      purpose="register"
      fallbackRedirect="/"
      restartRedirect="/Account/Register"
      restartMessage="Email not found. Please start the registration process again."
    />
  )
}
